import React, { useState } from 'react';
import { UncontrolledTooltip } from 'reactstrap';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button } from '../../../../../../shared/components';
import {
  EmissionsPurchasedElectricity,
  EmissionsRoadMaintenanceActivities,
} from '../../../../../../services/types/CalculatorTransportRoads';
import EmissionsRoadMaintenanceActivitiesSection from '../Modules/EmissionsRoadMaintenanceActivitiesSection';
import EmissionsPurchasedElectricitySection from '../Modules/EmissionsPurchasedElectricitySection';
import NumberFormatterSinSeparador from '../../NumberFormatterSinSeparador';
import { tooltipPreventOverflowModifiers } from '../../../../../../shared/misc/utils';

export interface TeamMember {
  imgPath?: string;
  name: string;
  initials: string;
}
interface Props {
  emissionsRoadMaintenanceActivities: EmissionsRoadMaintenanceActivities;
  setEmissionsRoadMaintenanceActivities: React.Dispatch<
    React.SetStateAction<EmissionsRoadMaintenanceActivities>
  >;
  emissionsPurchasedElectricity: EmissionsPurchasedElectricity;
  setEmissionsPurchasedElectricity: React.Dispatch<
    React.SetStateAction<EmissionsPurchasedElectricity>
  >;
}

const OperationTab: React.FC<Props> = ({
  emissionsRoadMaintenanceActivities,
  setEmissionsRoadMaintenanceActivities,
  emissionsPurchasedElectricity,
  setEmissionsPurchasedElectricity,
}) => {
  const { t } = useTranslation();

  const [expandedRows, setExpandedRows] = useState<number[]>([]);

  const handleRowToggle = (index: number) => {
    if (expandedRows.includes(index)) {
      setExpandedRows(expandedRows.filter((rowIndex) => rowIndex !== index));
    } else {
      setExpandedRows([...expandedRows, index]);
    }
  };

  const chevron = (index: number) =>
    expandedRows.includes(index) ? 'chevron-down' : 'chevron-right';

  return (
    <div className="timeline-list">
      {emissionsRoadMaintenanceActivities && (
        <div className="timeline-list-row calculator active">
          <div className="timeline-row-header-calculator">
            <div className="timeline-row-title-calculator">
              <Button
                className="btn-tertiary py-0 px-1 calc-no-transition"
                icon={chevron(0)}
                text={emissionsRoadMaintenanceActivities.name}
                type="button"
                onClick={() => handleRowToggle(0)}
              />
              {expandedRows.includes(0) && (
                <>
                  <span
                    id={`tr-emissionsRoadMaintenanceActivities-${emissionsRoadMaintenanceActivities.moduleId}`}
                  >
                    <FontAwesomeIcon icon="info-circle" className="calculator-icon" />
                  </span>
                  <UncontrolledTooltip
                    className="calculator-instruction"
                    placement="bottom"
                    target={`tr-emissionsRoadMaintenanceActivities-${emissionsRoadMaintenanceActivities.moduleId}`}
                    modifiers={tooltipPreventOverflowModifiers}
                  >
                    {t('moduleInstructions.EmissionsRoadMaintenanceActivities1')}
                    <br />
                    {t('moduleInstructions.EmissionsRoadMaintenanceActivities2')}
                  </UncontrolledTooltip>
                </>
              )}
            </div>
            {!expandedRows.includes(0) && emissionsRoadMaintenanceActivities.subTotal != null && (
              <div className="timeline-row-subtotal-calculator">
                Subtotal:{' '}
                <NumberFormatterSinSeparador value={emissionsRoadMaintenanceActivities.subTotal} />{' '}
                t CO<sub>2</sub>
              </div>
            )}
            <div className="timeline-row-empty-calculator" />
          </div>
          {expandedRows.includes(0) && (
            <EmissionsRoadMaintenanceActivitiesSection
              emissionsRoadMaintenanceActivities={emissionsRoadMaintenanceActivities}
              onUpdateEmissionsRoadMaintenanceActivities={(
                updatedEmissionsRoadMaintenanceActivities
              ) => setEmissionsRoadMaintenanceActivities(updatedEmissionsRoadMaintenanceActivities)}
            />
          )}
        </div>
      )}

      {/* FOR EMISSIONS FROM PURCHASED ELECTRICITY */}
      {emissionsPurchasedElectricity && (
        <div className="timeline-list-row calculator active">
          <div className="timeline-row-header-calculator">
            <div className="timeline-row-title-calculator">
              <Button
                className="btn-tertiary py-0 px-1 calc-no-transition"
                icon={chevron(1)}
                text={emissionsPurchasedElectricity.name}
                type="button"
                onClick={() => handleRowToggle(1)}
              />
              {expandedRows.includes(1) && (
                <>
                  <span
                    id={`tr-emissionsPurchasedElectricity-${emissionsPurchasedElectricity.moduleId}`}
                  >
                    <FontAwesomeIcon icon="info-circle" className="calculator-icon" />
                  </span>
                  <UncontrolledTooltip
                    className="calculator-instruction"
                    placement="bottom"
                    target={`tr-emissionsPurchasedElectricity-${emissionsPurchasedElectricity.moduleId}`}
                    modifiers={tooltipPreventOverflowModifiers}
                  >
                    {t('moduleInstructions.EmissionsPurchasedElectricity')}
                  </UncontrolledTooltip>
                </>
              )}
            </div>
            {!expandedRows.includes(1) && emissionsPurchasedElectricity.subTotal != null && (
              <div className="timeline-row-subtotal-calculator">
                Subtotal:{' '}
                <NumberFormatterSinSeparador value={emissionsPurchasedElectricity.subTotal} /> t CO
                <sub>2</sub>
              </div>
            )}
            <div className="timeline-row-empty-calculator" />
          </div>
          {expandedRows.includes(1) && (
            <EmissionsPurchasedElectricitySection
              emissionsPurchasedElectricity={emissionsPurchasedElectricity}
              onUpdateEmissionsPurchasedElectricity={(updatedEmissionsPurchasedElectricity) =>
                setEmissionsPurchasedElectricity(updatedEmissionsPurchasedElectricity)
              }
            />
          )}
        </div>
      )}
    </div>
  );
};

export default OperationTab;
